import { render, staticRenderFns } from "./NewsDetail375.vue?vue&type=template&id=3b32daa3&scoped=true"
import script from "./NewsDetail375.vue?vue&type=script&lang=js"
export * from "./NewsDetail375.vue?vue&type=script&lang=js"
import style0 from "./NewsDetail375.vue?vue&type=style&index=0&id=3b32daa3&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b32daa3",
  null
  
)

export default component.exports